type Props = {
    value: string | number;
};

export function String(props: Props) {
    return props.value;
}
